export default __webpack_public_path__ + "static/media/checklist.874acbc3.png";